import { keyframes, css } from 'styled-components';

/**
 * Shared visual idiom for every live-activity label in the chat —
 * "Pensando", "Pesquisando na web", "Executando comando", "Extraindo texto
 * dos arquivos", ... One look: a 15px leading icon (or ring) and a 0.88rem
 * medium label that shimmers while the activity is running and goes static
 * when it is done. Keep all indicator components on these pieces so the
 * layouts can't drift apart again.
 */

export const activityShimmer = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

/** Gradient-sweep text effect for an ACTIVE (running) activity label.
 *  Deliberately subtle: a narrow, low-contrast highlight on a slow sweep —
 *  enough to read "running" at a glance without flashing at the user. */
export const shimmerText = css`
  background: linear-gradient(
    90deg,
    ${({ theme }: any) =>
      theme.mode === 'dark' ? 'rgba(255,255,255,0.55)' : 'rgba(0,0,0,0.52)'} 35%,
    ${({ theme }: any) =>
      theme.mode === 'dark' ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.8)'} 50%,
    ${({ theme }: any) =>
      theme.mode === 'dark' ? 'rgba(255,255,255,0.55)' : 'rgba(0,0,0,0.52)'} 65%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${activityShimmer} 2.6s linear infinite;
`;
